'use client'

import NextLink from 'next/link'
import { AnalyticsLink, type SnowplowData } from '@components/analytics'
import NavLink from '@components/nav-link'
import { Icon, Typography } from '@shc/ui'
import { useTranslations } from 'next-intl'
import { useHeaderStore } from 'src/stores/header'

type AccountLinkProps = {
  extended?: boolean
  navLink?: boolean
}

const AccountLink = ({ extended = false, navLink = false }: AccountLinkProps) => {
  const reset = useHeaderStore((store) => store.reset)
  const translate = useTranslations('AccountLink')
  const buttonContent = translate('my_account')
  const accountLink = '/app'
  const snowplowData: SnowplowData = {
    event: {
      name: 'navigation_click',
      data: {
        navigation_tree: buttonContent,
        navigation_level: 1,
        navigation_subject: buttonContent,
        navigation_url: accountLink,
      },
    },
    contexts: [{ name: 'section', data: { section_name: 'header' } }],
  }

  return (
    <>
      {extended && (
        <Typography variant="h5" align="center" className="flex flex-row p-5 text-gray-700">
          <Icon icon="user" className="pr-1.5 pt-1.5" />
          <Typography variant="body-semibold" as="span" className="ml-2">
            {translate('welcome')}
          </Typography>
        </Typography>
      )}
      {navLink ? (
        <AnalyticsLink
          as={NavLink}
          asPassthru={NextLink}
          // @ts-expect-error This isn't a polymorphic component yet
          onNavigate={() => reset()}
          href={accountLink}
          className="text-sm !font-semibold hidden md:inline-block"
          snowplow={snowplowData}>
          {buttonContent}
        </AnalyticsLink>
      ) : (
        <AnalyticsLink
          asPassthru={NextLink}
          href={accountLink}
          onNavigate={() => reset()}
          noUnderline
          className="block p-2 m-3 text-sm"
          snowplow={snowplowData}>
          {buttonContent}
        </AnalyticsLink>
      )}
    </>
  )
}
export default AccountLink
